import logo from '../logo.svg';
import Button from "@mui/material/Button";
import {Link, useNavigate} from "react-router-dom";
import LoadingButton from '@mui/lab/LoadingButton';
import { red, grey } from '@mui/material/colors';
import apiConfig from "../util/apiConfig";

function App() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px"
      }}
    >
      <img src={"/Logo.png"} className="App-logo" alt="logo" style={{width: "70%"}}/>
      <p
        style={{
          color: "#fff",
          fontSize: "16px",
          fontWeight: 800,
          textAlign: "center",
          letterSpacing: "0.5px",
          marginTop: "50px"
        }}
      >
        THANK YOU FOR YOUR FEEDBACK
      </p>
      <Link to={apiConfig.booking_website_url}>
        <LoadingButton
          variant="contained"
          style={{
            // width: "100%",
            padding: "12px",
            fontSize: "12px",
            fontFamily: "Montserrat",
            letterSpacing: "1.5px",
            backgroundColor: red[900],
            marginTop : 20,

            "& .Mui-disabled": {
              backgroundColor: "#fff !important"
            }
          }}
        >
          <b>
            Back to Booking
          </b>
        </LoadingButton>
      </Link>
    </div>
  );
}

export default App;
